import { render, staticRenderFns } from "./itemDetalleAmarilla.vue?vue&type=template&id=e3e4714c&"
import script from "./itemDetalleAmarilla.vue?vue&type=script&lang=js&"
export * from "./itemDetalleAmarilla.vue?vue&type=script&lang=js&"
import style0 from "./itemDetalleAmarilla.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports